export default __webpack_public_path__ + "static/media/proflePic.e3c9e70e.jpeg";